import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";

import { actions } from "venuescanner-js/constants/leads";

import inboxService from "venuescanner-js/react/components/Inbox/services/inboxService";

const LeadIgnore = ({ lead }) => {
  const messageInputTextRef = useRef();
  const [selectedReason, setSelectedReason] = useState(null);

  const ignoreReasons = [
    "No availability",
    "Wrong event type",
    "Budget too low",
    "Other reason",
  ];
  const reasonButtons = ignoreReasons.map((reason) => (
    <span
      key={reason}
      className={`lead-ignore__reason ${
        selectedReason === reason ? "isSelected" : ""
      }`}
      onClick={(e) => {
        e.stopPropagation();
        setSelectedReason(reason);
      }}
    >
      {reason}
    </span>
  ));

  const handleSubmit = () => {
    return inboxService
      .leadIgnore({
        _id: lead._id,
        message: messageInputTextRef.current.value,
        reason: selectedReason,
      })
      .then((res) => {})
      .catch((err) => {
        console.log("LeadIgnore: submit error - ", err);
      });
  };

  return (
    <div className="lead-ignore" onClick={(e) => e.stopPropagation()}>
      <div className="lead-ignore__wrapper">
        <span className="h2">&#128075;</span>
        <p>
          Please tell us the reason why
          <br />
          you couldn't host this event
        </p>
        <div className="lead-ignore__reasons">{reasonButtons}</div>
        {selectedReason && (
          <div className="lead-ignore__lj-links">
            <p className="small">
              {selectedReason === "Budget too low"
                ? "Did you know that you can set different minimum budgets for different days of the week or for specific dates in the Flexible Pricing box in the Manage Venue section of your account? "
                : "Did you know that you can change the types of MatchLeads you receive by changing the event types and budgets that your venue is available for in the Manage Venue section of your account? "}
            </p>
            <a
              className="p small"
              href={`/manage/spaces/${lead.venue._id}/${lead.space._id}/${
                selectedReason === "Budget too low" ? "pricing" : "space_tags"
              }`}
            >
              {selectedReason === "Budget too low"
                ? "Update Pricing"
                : "Manage Venue"}
            </a>
          </div>
        )}
        {selectedReason && (
          <div className="lead-ignore__message">
            <span className="lead-ignore__message__caption p small">
              MatchLead feedback:
            </span>
            <textarea
              className="p small"
              name="message"
              ref={messageInputTextRef}
            />
          </div>
        )}
        <p className="small">
          Don’t worry, this feedback will not be sent to the organiser
        </p>
        <div className="lead-ignore__ctas">
          <Link
            to={`/inbox/leads/${lead._id}?status=${actions.ACCEPT.search_param}`}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="button button--outline-light">Go back</button>
          </Link>
          <button
            className={`button button--light ${
              selectedReason ? "isValid" : "isInvalid"
            }`}
            onClick={(e) => {
              e.stopPropagation();
              handleSubmit();
            }}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeadIgnore;
